"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINTS = exports.EPSILON = void 0;
exports.linePlaneIntersection = linePlaneIntersection;
exports.lineIntersectionPoint = lineIntersectionPoint;
exports.estimateDimensions = estimateDimensions;
exports.calculateFocalLength = calculateFocalLength;
const vector_1 = require("../vector");
exports.EPSILON = 2.220446049250313e-16;
exports.POINTS = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 2,
    BOTTOM_LEFT: 3,
};
function linePlaneIntersection(line, planeCenter, planeNormal) {
    var lineDir = line.end.subtract(line.start).unit();
    var p0MinusL0 = planeCenter.subtract(line.start);
    var numerator = p0MinusL0.dot(planeNormal);
    var denominator = lineDir.dot(planeNormal);
    var ratio = numerator / denominator;
    var lineSegment = lineDir.multiply(ratio);
    return line.start.add(lineSegment);
}
function lineIntersectionPoint(lineA, lineB) {
    let line1_start = lineA.start;
    let line1_end = lineA.end;
    let line2_start = lineB.start;
    let line2_end = lineB.end;
    let numeratorX = (line1_start.x * line1_end.y - line1_start.y * line1_end.x) * (line2_start.x - line2_end.x) -
        (line1_start.x - line1_end.x) * (line2_start.x * line2_end.y - line2_start.y * line2_end.x);
    let numeratorY = (line1_start.x * line1_end.y - line1_start.y * line1_end.x) * (line2_start.y - line2_end.y) -
        (line1_start.y - line1_end.y) * (line2_start.x * line2_end.y - line2_start.y * line2_end.x);
    let denominator = (line1_start.x - line1_end.x) * (line2_start.y - line2_end.y) -
        (line1_start.y - line1_end.y) * (line2_start.x - line2_end.x);
    if (denominator !== 0) {
        return new vector_1.Vector(numeratorX / denominator, numeratorY / denominator);
    }
    return null;
}
function estimateDimensions(quad) {
    let dimensions = new vector_1.Vector();
    let estimatedWidth1 = quad[exports.POINTS.BOTTOM_LEFT].subtract(quad[exports.POINTS.BOTTOM_RIGHT]).length();
    let estimatedWidth2 = quad[exports.POINTS.TOP_LEFT].subtract(quad[exports.POINTS.TOP_RIGHT]).length();
    let estimatedHeight1 = quad[exports.POINTS.BOTTOM_LEFT].subtract(quad[exports.POINTS.TOP_LEFT]).length();
    let estimatedHeight2 = quad[exports.POINTS.BOTTOM_RIGHT].subtract(quad[exports.POINTS.TOP_RIGHT]).length();
    dimensions.x = (estimatedWidth1 + estimatedWidth2) / 2.0;
    dimensions.y = (estimatedHeight1 + estimatedHeight2) / 2.0;
    return dimensions;
}
function calculateFocalLength(resolution, viewAngle) {
    var largestViewAngle = Math.max(viewAngle.horizontal, viewAngle.vertical);
    var largestLength = Math.max(resolution.width, resolution.height);
    var hvaTanHalf = Math.tan(largestViewAngle / 2.0);
    return largestLength / 2.0 / hvaTanHalf;
}
//# sourceMappingURL=geometry.util.js.map